export function getBlogExcerpt(body = '', limit = 100) {
  if (!body) {
    return '';
  }

  return body.length > limit ? `${body.slice(0, limit)} ...` : body;
}

export function getImageUrl(item, strapiURL = '') {
  const photos = item?.coverPhoto ? [item.coverPhoto] : item?.Photos || [];
  const photo = photos.find((candidate) => candidate?.formats?.small?.url || candidate?.url);
  const imagePath = photo?.formats?.small?.url || photo?.url || '';

  return imagePath ? `${strapiURL}${imagePath}` : '';
}

export function getRandomCollectionPath(items = [], randomFn = Math.random) {
  if (!items.length) {
    return '/collection';
  }

  const index = Math.min(Math.floor(randomFn() * items.length), items.length - 1);
  const documentId = items[index]?.documentId;

  return documentId ? `/collection/${documentId}` : '/collection';
}

export function getSafeDateLabel(date) {
  return date || '-';
}
